import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Typography } from "./Typhograpy";

const InfoIcon = ({ info, size = "md", type = "text" }) => {
  const renderContent = () => {
    if (type === "html") {
      return (
        <Typography
          variant="caption"
          style={{ overflow: "unset", whiteSpace: "unset", textAlign: "left" }}
          dangerouslySetInnerHTML={{ __html: info }}
        />
      );
    }
    return (
      <Typography
        variant="caption"
        style={{ overflow: "unset", whiteSpace: "unset", textAlign: "left" }}
      >
        {info}
      </Typography>
    );
  };

  return (
    <OverlayTrigger
      placement="right"
      overlay={<Tooltip id="tooltip-info">{renderContent()}</Tooltip>}
    >
      <FontAwesomeIcon
        style={{ marginLeft: "3px", cursor: "pointer", fontSize: "12px" }}
        icon={faInfoCircle}
        size={size}
        color="gray"
      />
    </OverlayTrigger>
  );
};

export default InfoIcon;
